/// <reference types="@types/googlemaps" />
import { ChangeDetectorRef, Component, ElementRef, Inject, NgZone, OnInit, ViewChild } from '@angular/core';
import { GoogleMap, MapInfoWindow, MapMarker } from '@angular/google-maps';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { GeneralService } from 'src/app/core/services';
import { UserGeolocationService } from 'src/app/core/services/user-geolocation.service';
import { APP_STATE_TOKEN } from 'src/app/core/store';
import { IGeoCoordinate, IUserGeolocation } from 'src/app/core/types/user-geolocation.interface';
import { CONSTANTS } from 'src/app/core/utils/constants';

interface ILocal {
  position: google.maps.LatLngLiteral;
  label: string;
  title: string;
  options: google.maps.MarkerOptions;
}

@Component({
  selector: 'app-modal-ubicacion-locales-universidad',
  templateUrl: './modal-ubicacion-locales-universidad.component.html',
  styleUrls: ['./modal-ubicacion-locales-universidad.component.scss']
})
export class ModalUbicacionLocalesUniversidadComponent implements OnInit {

  locales: ILocal[] = [];

  defaultPosition: IGeoCoordinate = { lat: -12.062106, lng: -77.036526 };

  position: IGeoCoordinate = null;

  address: string;

  mapOptions: google.maps.MapOptions;

  infoWindowOptions: google.maps.InfoWindowOptions;

  center: google.maps.LatLngLiteral = this.defaultPosition;

  zoom = 14;

  @ViewChild(GoogleMap, { static: false }) map: GoogleMap;

  @ViewChild(MapMarker, { static: false }) public markerReference: MapMarker;

  @ViewChild(MapInfoWindow, { static: false }) infoWindow: MapInfoWindow;

  geocoder = new google.maps.Geocoder;

  infoWindowMessage: string = null;

  @ViewChild('gmap') gmap: GoogleMap;

  userMarker: ILocal = null;

  constructor(
    public dialogRef: MatDialogRef<ModalUbicacionLocalesUniversidadComponent>,
    private ngZone: NgZone,
    private store: Store,
    private userGeolocationService: UserGeolocationService,
    private cd: ChangeDetectorRef,
    private generalService: GeneralService,
    @Inject(MAT_DIALOG_DATA) public data: { idEntidad, idPrograma, idProgramaDocumento, hideUserLocation: boolean }
  ) {
    this.setMapOptions();
  }

  ngOnInit() {
    this.geocoder = new google.maps.Geocoder();
    this.setUserMarker();
    this.listarLocalesEntidad();
  }

  ngAfterViewInit() {
  }

  // ===========================================================
  // #region METHODS
  // ===========================================================

  private setMapOptions = () => {
    this.mapOptions = {
      ...CONSTANTS.DEFAULT_MAP_OPTIONS,
      mapTypeControl: false,
      streetViewControl: false,
      zoomControl: false,
      scrollwheel: false,
      disableDoubleClickZoom: true,
      maxZoom: 15,
      minZoom: 8,
      fullscreenControl: true
    };
  }

  // ===========================================================
  // #region HANDLER METHODS
  // ===========================================================

  handleClose = () => {
    this.dialogRef.close();
  }

  private setInfoWindowMessage = (msg: string) => {
    this.infoWindowMessage = msg;
    this.infoWindowOptions = {
      ...this.infoWindowOptions,
      position: this.position
    };

    this.infoWindow.open(this.markerReference);
  }

  // private setMarkerPosition = (position: IGeoCoordinate) => {
  //   this.marker = {
  //     ...this.marker,
  //     position: position
  //   };
  // }

  private setMapCenter = (center: IGeoCoordinate) => {
    this.center = center;
  }

  private setMapZoom = (zoom: number) => {
    this.zoom = zoom;
  }

  private setPosition = (position: IGeoCoordinate) => {
    this.position = position;
  }

  private setAddress = (address: string) => {
    this.address = address;
  }

  private listarLocalesEntidad = () => {
    const { globalConfig: { userGeoLocation } } = this.store.selectSnapshot(APP_STATE_TOKEN);
    const obs = (this.data.idPrograma ?
      this.generalService.getLocalesEntidadPrograma(
        this.data.idEntidad,
        this.data.idPrograma,
        this.data.idProgramaDocumento??0,
        userGeoLocation ? userGeoLocation.position : null
      ) :
      this.generalService.getLocalesEntidad(
        this.data.idEntidad,
        userGeoLocation ? userGeoLocation.position : null
      )
    );

    obs.subscribe((response) => {
      this.locales = response.data.map(x => ({
        position: { lat: x.latitud, lng: x.longitud },
        label: null,
        title: `${x.direccion} ${x.departamento}/${x.provincia}/${x.distrito}`,
        options: { draggable: false }
      }));

      if (this.userMarker) {
        this.locales = [...this.locales, this.userMarker];
      }

      if (this.locales.length > 1) {
        this.fitMapMarkers();
      } else {
        this.setMapLocal()
      }
    });
  }

  private fitMapMarkers = () => {
    let latlngbounds = new google.maps.LatLngBounds();

    this.locales.forEach((x, index) => {
      latlngbounds.extend({ lat: x.position.lat, lng: x.position.lng });
    });

    this.gmap.fitBounds(latlngbounds, 0);
  }

  private setMapLocal = () => {
    const local = this.locales[0];
    this.setMapCenter({ lat: local.position.lat, lng: local.position.lng });
    this.setMapZoom(16);
  }

  private setUserMarker = () => {
    const { globalConfig: { userGeoLocation } } = this.store.selectSnapshot(APP_STATE_TOKEN);
    if (userGeoLocation && !this.data.hideUserLocation) {
      this.userMarker = {
        title: userGeoLocation.address,
        label: null,
        position: { ...userGeoLocation.position },
        options: { draggable: false, icon: '/assets/img/png/map-blue-dot.png' }
      };
    }
  }

}
